import { isEmpty } from '../../core/util';

export const questionsAnswered = (...boolQuestions) =>
  boolQuestions.every(question => typeof question === 'boolean');

export const answeredNo = question => question === false;

export const noEmptyAccounts = accountsArray =>
  accountsArray.length > 0 &&
  accountsArray.filter(acct => isEmpty(acct.accountName)).length === 0;

const formCompleted = (
  selectedCustodian,
  fundsInBrokerage,
  preliquidated,
  errorFlag
) =>
  selectedCustodian.custodianName !== '' &&
  ((answeredNo(fundsInBrokerage) && !errorFlag) ||
    questionsAnswered(fundsInBrokerage, preliquidated));

export const shouldValidate = (
  selectedCustodian,
  fundsInBrokerage,
  preliquidated,
  externalAccounts,
  editFunding,
  errorFlag
) =>
  (formCompleted(
    selectedCustodian,
    fundsInBrokerage,
    preliquidated,
    errorFlag
  ) &&
    editFunding) ||
  noEmptyAccounts(externalAccounts);

export const cleanTicker = value => value.replace(/\(.*/gi, '');
